import {
  Component,
  input,
  signal,
  OnDestroy,
  inject,
  effect,
  viewChild,
  ElementRef,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'lib-app-pdf-viewer',
  imports: [],
  templateUrl: './pdf-viewer.html',
})
export class PdfViewer implements OnDestroy {
  private sanitizer = inject(DomSanitizer);

  pdfSource = input<string | null>(null);

  height = input<string>('80vh');

  width = input<string>('100%');

  customClass = input<string>('');

  /** PDF.js embed view: `Fit` = whole page in frame (A4 boxes), `FitH` = fit width. */
  pdfView = input<'Fit' | 'FitH'>('FitH');

  /**
   * Brauzerning o'zi ko'rsatadigan native PDF toolbar (yuklab olish, Drive'ga
   * saqlash, chop etish). false bo'lsa — blob/data manba uchun ham yashiriladi;
   * shu holda `print()` metodidan foydalanib faqat chop etishni taqdim eting.
   */
  showToolbar = input<boolean>(true);

  private readonly frameRef =
    viewChild<ElementRef<HTMLIFrameElement>>('pdfFrame');

  safePdfUrl = signal<SafeResourceUrl | null>(null);

  constructor() {
    // Use effect to watch for pdfSource changes
    effect(() => {
      const source = this.pdfSource();
      this.updateSafeUrl(source);
    });
  }

  private updateSafeUrl(source: string | null) {
    if (source) {
      const viewerUrl = this.buildViewerUrl(source);
      const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(viewerUrl);
      this.safePdfUrl.set(safeUrl);
    } else {
      this.safePdfUrl.set(null);
    }
  }

  private buildViewerUrl(source: string): string {
    const isBlobOrData = source.startsWith('blob:') || source.startsWith('data:');
    // Odatiy holatda blob/data manbalarga hash parametr qo'shilmaydi — native
    // toolbar (yuklab olish h.k.) ko'rinadi. showToolbar=false bo'lsa, bu
    // manbalar uchun ham toolbar yashiriladi.
    if (isBlobOrData && this.showToolbar()) {
      return source;
    }

    const viewerParams = `toolbar=0&navpanes=0&view=${this.pdfView()}`;
    return source.includes('#') ? `${source}&${viewerParams}` : `${source}#${viewerParams}`;
  }

  /** Native toolbar yashirilganda (showToolbar=false) chop etishni ishga tushiradi. */
  print(): void {
    this.frameRef()?.nativeElement.contentWindow?.print();
  }

  ngOnDestroy(): void {
    this.safePdfUrl.set(null);
  }
}
